// composables/api.ts
import { useFetch, useNuxtApp, useRuntimeConfig } from '#app';
import _ from 'lodash';
import moment from 'moment';
import { ENUM } from '~/plugins/constants/enum';
import { LOCAL_STORAGE } from '~/plugins/constants/localStorage';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from '~/plugins/functions/localStorage';

const saveSessionExpiry = (headers: Headers | Record<string, string>) => {
  const expiry = headers instanceof Headers
    ? headers.get('session-expiry')
    : headers['session-expiry'];
  if (expiry) {
    setLocalStorage(LOCAL_STORAGE.SESSION_EXPIRY, expiry);
  }
};

export const useApi = async (url: string, configService: any, option?: any) => {
  const runtimeConfig = useRuntimeConfig();
  const res = useFetch(`${runtimeConfig.public.apiBase}${url}`, {
    ...option,
    headers: {
      ...option?.headers,
      'x-user-timezone': moment().utcOffset()
    },
    onRequest(req: any) {
      const accessToken = getLocalStorage(LOCAL_STORAGE.OAUTH_ACCESS_TOKEN);
      if (accessToken) {
        req.options.headers.set('Authorization', `Bearer ${accessToken}`);
      }
    },
    onResponse(ctx: any) {
      saveSessionExpiry(ctx.response.headers);
    },
    onResponseError(err: any) {
      const { $functions } = useNuxtApp();
      // Handle the errponse errors
      console.log('onResponseError', err)
      const res = err.response;
      const resMessage = _.get(res, '_data.message', '')
      const resError = _.get(res, '_data.error', '')
      const resstatusCode = _.get(res, '_data.statusCode', '')
      if (resMessage === ENUM.API_RESPONSE_MESSAGE.UNAUTHORIZED || resError === ENUM.API_RESPONSE_MESSAGE.UNAUTHORIZED || resstatusCode === ENUM.API_RESPONSE_STATUS.UNAUTHORIZED) {
        removeLocalStorage(LOCAL_STORAGE.OAUTH_ACCESS_TOKEN);
        window.location.reload();
      }
      $functions.notify.error({
        text: resMessage
      });
    }
  });
  return res
}

export const useApiFetchSSE = async (url: string, option?: any): Promise<Response> => {
  const runtimeConfig = useRuntimeConfig();
  const accessToken = getLocalStorage(LOCAL_STORAGE.OAUTH_ACCESS_TOKEN);
  
  const response = await fetch(`${runtimeConfig.public.apiBase}${url}`, {
    ...option,
    headers: {
      ...option?.headers,
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      'x-user-timezone': moment().utcOffset(),
    },
    signal: option?.signal,
  });
  
  saveSessionExpiry(response.headers);

  if (!response.ok) {
    const { $functions } = useNuxtApp();
    let errorMessage = `HTTP error! status: ${response.status}`;
    try {
      const errorData = await response.json();
      errorMessage = errorData.message || errorData.error || errorMessage;
    } catch (e) {
      // If can't parse JSON, try text
      try {
        errorMessage = await response.text() || errorMessage;
      } catch (textError) {
        // Use default error message
      }
    }
    
    if (response.status === 401) {
      removeLocalStorage(LOCAL_STORAGE.OAUTH_ACCESS_TOKEN);
      window.location.reload();
    }
    
    $functions.notify.error({
      text: errorMessage
    });
  }
  
  return response;
}

export const useApiLogin = async (url: string, configService: any, option?: any) => {
  const runtimeConfig = useRuntimeConfig();
  const res = useFetch(`${runtimeConfig.public.apiBase}${url}`, {
    ...option,
    headers: {
      ...option?.headers,
      'x-user-timezone': moment().utcOffset()
    },
    onRequest(req: any) {
      const accessToken = getLocalStorage(LOCAL_STORAGE.OAUTH_ACCESS_TOKEN);
      if (accessToken) {
        req.options.headers.set('Authorization', `Bearer ${accessToken}`);
      }
    },
    onResponse(ctx: any) {
      saveSessionExpiry(ctx.response.headers);
    },
    onResponseError(err: any) {
      const { $functions } = useNuxtApp();
      // Handle the errponse errors
      console.log('onResponseError', err)
      const res = err.response;
      const resMessage = _.get(res, '_data.message', '')
      const resError = _.get(res, '_data.error', '')
      const resstatusCode = _.get(res, '_data.statusCode', '')
      if (resMessage === ENUM.API_RESPONSE_MESSAGE.UNAUTHORIZED ||
        resError === ENUM.API_RESPONSE_MESSAGE.UNAUTHORIZED ||
        resstatusCode === ENUM.API_RESPONSE_STATUS.UNAUTHORIZED)
      {
        removeLocalStorage(LOCAL_STORAGE.OAUTH_ACCESS_TOKEN);
      }
      $functions.notify.error({
        text: resMessage
      });
    }
  });
  return res
}
